<template>
  <v-container fluid class="notifications">
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>

    <v-layout row wrap class="mt-2">
      <v-flex md10 offset-md1 xs12 offset-xs>
          <h4 class="green--text headline mb-4">Notificaciones</h4>

          <v-card light class="pa-4">
            <v-layout row wrap>
              <v-flex class="mb-5 left-panel" v-if="sportPlaces.length > 0">
                <h5 class="grey--text headline mb-3">Complejos</h5>
                <!--
                  <v-flex v-if="sportPlaces.length > 0" xs11 md11  d-flex align-center>
                    <v-btn color="primary" @click.native="selectCleanSportPlaces(true)" small>Seleccionar todo</v-btn>
                    <v-btn color="primary" @click.native="selectCleanSportPlaces(false)" small>Limpiar</v-btn>
                  </v-flex>
                -->
                <!-- Listado de complejos -->
                <div class="scroll-section">
                  <v-checkbox v-for="(sportPlace,i) in sportPlaces" :key="'set' + i"
                    light
                    :label="sportPlace.name"
                    v-model="sportPlace.selected"
                    :hide-details="true"
                    :ripple="false">
                  </v-checkbox>
                </div>
              </v-flex>

              <v-flex class="mb-5 left-panel">
                <h5 class="grey--text headline mb-3">Torneos activos</h5>
                <!--
                  <v-flex xs11 md11  d-flex align-center>
                    <v-btn color="primary" @click.native="selectCleanTournaments(true)" small>Seleccionar todo</v-btn>
                    <v-btn color="primary" @click.native="selectCleanTournaments(false)" small>Limpiar</v-btn>
                  </v-flex>
                  -->
                <!-- Listado de Torneos -->
                <div class="scroll-section">
                  <v-checkbox v-for="(tournament,i) in tournaments" :key="'tournament' + i"
                    light
                    :label="tournament.name"
                    v-model="tournament.selected"
                    :hide-details="true"
                    :ripple="false">
                  </v-checkbox>
                </div>
              </v-flex>

              <v-flex class="mb-5 right-panel">
                <h5 class="grey--text headline mb-3">Equipos ligados</h5>

                <div v-if="this.teams.length > 0" class="mb-2">
                  <v-btn class="ml-0" @click.native="selectCleanTeams(true)" color="green" small>
                    Seleccionar todo
                  </v-btn>

                  <v-btn @click.native="selectCleanTeams(false)" color="green" small>
                    Limpiar selección
                  </v-btn>
                </div>

                <!-- Listado de equipos -->
                <div class="scroll-section">
                  <v-checkbox v-for="(team,i) in teams" :key="'team' + i"
                    light
                    :label="team.name"
                    v-model="team.selected"
                    :hide-details="true"
                    :ripple="false">
                  </v-checkbox>
                </div>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  class="text-field"
                  light
                  maxlength="200"
                  minlength="8"
                  name="input-1"
                  label="Mensaje de notificación (200 caracteres maximo)"
                  id="notificationMSG"
                  v-model="notificationMessage">
                </v-text-field>

                <v-checkbox label="Solo enviar a administradores"
                  v-model="onlyAdmins"
                  light
                  :hide-details="true">
                </v-checkbox>

                <div class="notifications-footer">
                  <v-btn @click.native="startSendNotifications()" color="primary" big>
                    Enviar notificaciones
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "Notifications",
  data: () => ({
    messageLoader: 'Cargando Filtros',
    filter: '',
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres notificar a {{teams}} equipo(s)?',
    confirmMessageTXT: '¿Estas seguro que quieres notificar a {{teams}} equipo(s)?',
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    notificationMessage:"",
    onlyAdmins: false

  }),
  mounted() {
    this.messageLoader = "Cargando Filtros"
    this.loadNotificationsFilters()
  },
  computed: {
    ...mapGetters([
      "currentNotificationsFilters",
      "notificationTeamsFilter",
      "notificationSportPlacesFilter",
      "notificationTournamentsFilter"
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ]),
    teams(){
      var result = []
      for(var i in this.notificationTeamsFilter){
        var team = this.notificationTeamsFilter[i]
        for(var x in this.selectedTournaments){
          if(this.selectedTournaments[x] == team.active_tournament_id){
            result.push(team)
          }
        }
      }
      return result
    },
    sportPlaces(){
      return this.notificationSportPlacesFilter
    },
    tournaments(){
      if(this.notificationSportPlacesFilter.length == 0){
        return this.notificationTournamentsFilter
      }
      var result = []
      for(var i in this.notificationTournamentsFilter){
        var tournament = this.notificationTournamentsFilter[i]
        for(var x in this.selectedSportPlaces){
          if(this.selectedSportPlaces[x] == tournament.sport_place_id){
            result.push(tournament)
          }
        }
      }
      return result
    },
    selectedSportPlaces(){
        var result = []
        for(var i in this.notificationSportPlacesFilter){
          var sportPlace = this.notificationSportPlacesFilter[i]
          if(sportPlace.selected){
            result.push(sportPlace.id)
          }
        }

        return result
    },
    selectedTournaments(){
        var result = []
        for(var i in this.notificationTournamentsFilter){
          var tournament = this.notificationTournamentsFilter[i]
          if(tournament.selected){
            result.push(tournament.id)
          }
        }

        return result
    }

  },
  methods: {
    ...mapActions([
      'loadNotificationsFilters',
      'sendNotifications'
    ]),
    selectCleanSportPlaces(select){
      for(var i in this.notificationSportPlacesFilter){
        this.notificationSportPlacesFilter[i].selected = select
      }
    },
    selectCleanTournaments(select){
      for(var i in this.notificationTournamentsFilter){
        this.notificationTournamentsFilter[i].selected = select
      }
    },
    selectCleanTeams(select){
      console.log("selectCleanTeams",select)
      for(var i in this.teams){
        console.log("selectCleanTeams",select)
        this.teams[i].selected = select
      }
    },
    getSelectedTeamsIds(){
      var result = []
      for(var i in this.teams){
        let team = this.teams[i]
        if(team.selected){
          result.push(team.id)
        }
      }
      return result
    },
    startSendNotifications(){
      let ids = this.getSelectedTeamsIds()
      this.confirmMessage = this.confirmMessageTXT.replace("{{teams}}",ids.length+"")
      this.showConfirm = true
      console.log("startSendNotifications",ids)
    },
    confirmResponse(confirm){
      this.showConfirm = false
      let data = {
        teamsids:this.getSelectedTeamsIds(),
        msg: this.notificationMessage,
        onlyAdmins: this.onlyAdmins
      }
      this.messageLoader = "Enviando notificaciones"
      this.sendNotifications(data)
    }
  }
}
</script>
<style lang="css" scoped>
.scroll-section {
  max-height: 320px;
  overflow-y: auto;
}

.scroll-section .input-group {
  overflow: hidden;
}

.scroll-section >>> .ripple__container {
  display: none !important; /* hide ripple on checkbox elements */
}

.left-panel {
  flex: 1;
  max-width: 420px;
  min-width: 220px;
  border-right: 1px solid rgba(0,0,0,.14);
  padding-left: 27px;
}
.left-panel:first-child {
  padding-left: 0;
}

.right-panel {
  /* width: calc(100% - 480px); */
  padding-left: 27px;
}

.notifications-footer {
  display: flex;
}

.notifications-footer .btn {
  margin: 0 0 0 auto;
}

.text-field {
  max-width: 700px;
}

@media screen and (max-width: 900px) {
  .right-panel,
  .left-panel {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    padding-left: 0;
    border: 0;
  }

  .scroll-section {
    max-height: 180px;
    background-color: #fafafa;
    border: 1px solid #EEE;
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/notifications/notifications.vue